import { render, staticRenderFns } from "./TeamLoadChart.vue?vue&type=template&id=ab66083a"
import script from "./TeamLoadChart.vue?vue&type=script&lang=js"
export * from "./TeamLoadChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports